import React from "react";
import "./Licenses.css";

const fonts = [
    {
        name: "Comic Neue",
        cssName: "ComicNeue",
        license: "OFL.txt"
    },
    {
        name: "Bebas Neue",
        cssName: "BebasNeue",
        license: "OFL.txt"
    },
    {
        name: "Comic Relief",
        cssName: "ComicRelief",
        license: "OFL.txt"
    },
    {
        name: "Lora",
        cssName: "Lora",
        license: "OFL.txt"
    },
    {
        name: "Montserrat",
        cssName: "Montserrat",
        license: "OFL.txt"
    },
    {
        name: "Oswald",
        cssName: "Oswald",
        license: "OFL.txt"
    },
    {
        name: "Pacifico",
        cssName: "Pacifico",
        license: "OFL.txt"
    },
    {
        name: "Playfair Display",
        cssName: "PlayfairDisplay",
        license: "OFL.txt"
    },
    {
        name: "Roboto",
        cssName: "Roboto",
        license: "OFL.txt"
    },
    {
        name: "Satoshi",
        cssName: "Satoshi",
        license: "FFL.txt"
    }
];

function LicenseLink({ file, children }) {
    return (
        <a
            className="license-link"
            href={`/licenses/${file}`}
            target="_blank"
            rel="noopener noreferrer"
        >
            {children}
            <span className="license-link-icon">↗</span>
        </a>
    );
}

export default function Licenses() {
    return (
        <div className="licenses-page">

            <header className="licenses-header">
                <div className="licenses-header-inner">
                    <div className="licenses-eyebrow">
                        OPEN SOURCE & THIRD-PARTY SOFTWARE
                    </div>

                    <h1>Licenses</h1>

                    <p>
                        MyAIWeb uses a number of open-source fonts and
                        third-party libraries. This page provides information
                        about the software and resources included with the
                        application and links to their respective licenses.
                    </p>
                </div>
            </header>

            <main className="licenses-content">

                {/* Fonts */}
                <section className="license-section">

                    <div className="section-heading">
                        <div className="section-number">01</div>

                        <div>
                            <h2>Fonts</h2>
                            <p>
                                The following fonts are included with
                                MyAIWeb and are distributed under their
                                respective licenses.
                            </p>
                        </div>
                    </div>

                    <div className="font-list">

                        {fonts.map((font) => (
                            <div
                                className="font-license-card"
                                key={font.name}
                            >
                                <div className="font-information">

                                    <div
                                        className="font-preview"
                                        style={{
                                            fontFamily: `"${font.cssName}"`
                                        }}
                                    >
                                        Aa
                                    </div>

                                    <div className="font-details">
                                        <h3>{font.name}</h3>

                                        <span className="font-license-name">
                                            {font.license === "FFL.txt"
                                                ? "Font/Freely Licensed"
                                                : "SIL Open Font License"}
                                        </span>
                                    </div>
                                </div>

                                <LicenseLink file={font.license}>
                                    View license
                                </LicenseLink>
                            </div>
                        ))}

                    </div>
                </section>


                {/* Three.js */}
                <section className="license-section">

                    <div className="section-heading">
                        <div className="section-number">02</div>

                        <div>
                            <h2>Three.js</h2>

                            <p>
                                MyAIWeb uses Three.js for 3D graphics and
                                interactive 3D content.
                            </p>
                        </div>
                    </div>

                    <div className="software-license-card">

                        <div className="software-icon">
                            3D
                        </div>

                        <div className="software-details">
                            <h3>Three.js</h3>

                            <p>
                                JavaScript 3D rendering library.
                            </p>

                            <span>
                                License: MIT
                            </span>
                        </div>

                        <LicenseLink file="three-license.txt">
                            View license
                        </LicenseLink>

                    </div>
                </section>


                {/* OpenMoji */}
                <section className="license-section">

                    <div className="section-heading">
                        <div className="section-number">03</div>

                        <div>
                            <h2>OpenMoji</h2>

                            <p>
                                MyAIWeb uses OpenMoji for its collection of
                                open-source emoji graphics.
                            </p>
                        </div>
                    </div>

                    <div className="software-license-card">

                        <div className="software-icon emoji-icon">
                            😊
                        </div>

                        <div className="software-details">
                            <h3>OpenMoji</h3>

                            <p>
                                Open-source emoji set provided by the
                                OpenMoji project.
                            </p>

                            <span>
                                License: Creative Commons BY-SA 4.0
                            </span>
                        </div>

                        <LicenseLink file="openmoji-license.txt">
                            View license
                        </LicenseLink>

                    </div>
                </section>


                <div className="licenses-footer">
                    <p>
                        These third-party resources remain subject to their
                        respective licenses. Please refer to the linked license
                        files for the complete terms and conditions.
                    </p>
                </div>

            </main>
        </div>
    );
}